import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

import SelectAvatar from './SelectAvatar';
import FormAvatar from './FormAvatar';

const WrapperAvatarEdition = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    height: 100%;
  `};
`;

const SelectAvatarOW = styled(SelectAvatar)`
  width: 100%;
  padding: ${rem('20px')} 0;
  background-color: ${props => props.theme.colors.grayLightest};
  overflow-x: auto;
  position: relative;
  &:after {
    content: '';
    width: ${rem('12px')};
    height: ${rem('162px')};
    position: fixed;
    bottom: 0;
    right: 0;

    background: linear-gradient(
      to right,
      rgba(189, 189, 189, 0) 0%,
      rgba(0, 0, 0, 1) 100%
    );
  }

  ${mediaqueries.greaterThan('desktop')`
    align-items: center;
    display: flex;
    max-height: none;    
    height:100%;
    overflow: hidden;
    &:after{
      content: none;
    }
  `};
`;

const FormAvatarOW = styled(FormAvatar)`
  padding: ${rem('25px')} 0;
  margin-bottom: 0;

  ${mediaqueries.greaterThan('mobile')`
    padding: 0 ${rem('35px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  `};
`;

export { WrapperAvatarEdition, FormAvatarOW, SelectAvatarOW };
